import { Theme } from "@mui/material/styles";

export const dropZoneContainer = (theme: Theme) => {
    const { palette } = theme;
    const color = palette.info.main;
    return {
        width: "100%",
        marginTop: "20px",
        fontSize: "1rem",
        outline: "none",
        border: "4px dashed #c8c8c8",
        backgroundColor: "#f0f0f0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        transition: "border-color .3s ease",
        padding: "1rem 2rem",
        "&:hover": { border: "4px solid transparent", textDecoration: "underline", cursor: "pointer" },
    };
};

export const previewImageContainer = (theme: Theme) => {
    return {
        position: "relative",
        border: "1px solid #c3c3c3",
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        "&:hover": {
            cursor: "pointer",
            "& .MuiBox-root": {
                visibility: "inherit",
                transition: "0.3s ease all",
            },
        },
    };
};

export const image = () => ({
    width: "100%",
    height: 150,
    objectFit: "contain",
});

export const actionBox = (theme: Theme) => {
    const { functions } = theme;
    const { rgba } = functions;
    return {
        position: "absolute",
        backgroundColor: rgba("#000000", 0.5),
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 2,
        width: "100%",
        height: "100%",
        visibility: "hidden",
    };
};
